var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkEnvelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74432 26C5.07076 26 4.50065 25.7667 4.03398 25.3C3.56732 24.8333 3.33398 24.2632 3.33398 23.5897V8.41033C3.33398 7.73678 3.56732 7.16667 4.03398 6.7C4.50065 6.23333 5.07076 6 5.74432 6H26.257C26.9305 6 27.5007 6.23333 27.9673 6.7C28.434 7.16667 28.6673 7.73678 28.6673 8.41033V23.5897C28.6673 24.2632 28.434 24.8333 27.9673 25.3C27.5007 25.7667 26.9305 26 26.257 26H5.74432ZM26.6673 9.923L16.6493 16.336C16.5469 16.394 16.4409 16.4397 16.3313 16.473C16.222 16.5063 16.1118 16.523 16.0007 16.523C15.8895 16.523 15.7793 16.5063 15.67 16.473C15.5604 16.4397 15.4544 16.394 15.352 16.336L5.33398 9.923V23.5897C5.33398 23.7094 5.37243 23.8078 5.44932 23.8847C5.52621 23.9616 5.62454 24 5.74432 24H26.257C26.3768 24 26.4751 23.9616 26.552 23.8847C26.6289 23.8078 26.6673 23.7094 26.6673 23.5897V9.923ZM16.0007 14.6667L26.4623 8H5.53898L16.0007 14.6667ZM5.33398 10.2307V8.70633V8.746V8.70367V10.2307Z",
    fill: "#252B42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEnvelop);
export default __webpack_public_path__ + "static/media/dark-envelop.d6aeb003ee82c849b5fac599e47c1d09.svg";
export { ForwardRef as ReactComponent };